import React from "react";
import styles from "./MobilePager.module.scss";
import { MobilePagerDot } from "../../model/types";

interface MobilePagerProps {
  dots: MobilePagerDot[];
  onDotClick: (index: number) => void;
  isAnimating?: boolean;
}

export const MobilePager: React.FC<MobilePagerProps> = ({
  dots,
  onDotClick,
  isAnimating = false,
}) => {
  return (
    <div className={styles.mPager}>
      {dots.map((dot) => (
        <button
          key={dot.index}
          type="button"
          className={`${styles.mDot} ${dot.isActive ? styles.active : ""}`}
          onClick={() => !isAnimating && onDotClick(dot.index)}
          disabled={isAnimating}
          aria-label={`Перейти к периоду ${dot.index + 1}`}
        />
      ))}
    </div>
  );
};

